import React from 'react';
const links = ['Terms & Conditions', 'Privacy Policy', 'Contact'];
export function Footer() {
  return <footer className="bg-navy-deep px-4 py-5 text-center sm:px-6" data-id="element-67" data-mp="3gfiswe27a3c0">
      <p className="text-[11px] font-bold text-cream/80" data-id="element-68" data-mp="32nummremu92y">
        © 2026 SENIOR ACTIVITY READY™ — All Rights Reserved.
      </p>
      <p className="mx-auto mt-2 max-w-2xl text-[10px] font-medium leading-snug text-cream/50 sm:text-[11px]" data-id="element-69" data-mp="36ooajks2rnvu">
        This system provides recreational and educational activity resources for
        professionals working with older adults. It does not provide medical
        advice, diagnosis, treatment, rehabilitation or individualized healthcare
        guidance. Activities should be adapted according to participant
        preferences, individual abilities, the environment, organizational
        procedures and relevant professional guidance when appropriate.
      </p>
      <nav aria-label="Legal links" className="mt-3" data-id="element-70" data-mp="2ey0bce9yoskt">
        <ul className="flex flex-wrap justify-center gap-x-2 gap-y-1 text-[10px] font-bold uppercase tracking-wide text-cream/70 sm:text-[11px]" data-id="element-71" data-mp="2ezl35w4w5xez">
          {links.map((link, index) => <li key={link} className="flex items-center gap-2" data-id="element-72" data-mp="3gc0ffejw1k4z" data-mpi={index}>
              <a href="#" className="transition-colors duration-150 ease-out hover:text-mustard" data-id="element-73" data-mp="3v89fgibls1ig">
                {link}
              </a>
              {index < links.length - 1 && <span aria-hidden="true" className="text-cream/30" data-id="element-74" data-mp="81fnrqp54i1k">
                  •
                </span>}
            </li>)}
        </ul>
      </nav>
    </footer>;
}